<template>
  <lk-modal
    v-model="modalShow"
    :closable='false'
    :mask-closable='false'
    width="420"
    title="账户类型"
    @on-visible-change='handleModal'
    >
    <div class="container">
      <lk-form
        :label-width="80"
      >
        <lk-form-item label="选择账户:" prop="selectedUser">
          <lk-select v-model="storeId">
            <lk-option v-for="item in user.sysStoreList"
            :key="item.id"
            :value='item.id'>{{item.id===1?'总部账户':('门店账户-'+item.name)}}</lk-option>
          </lk-select>
        </lk-form-item>
      </lk-form>
    </div>
    <div slot="footer">
      <lk-button class="cancel" @click="closeModal" >取消</lk-button>
      <lk-button type='primary' @click="onConfirm">确定</lk-button>
    </div>
  </lk-modal>
</template>
<script>
import mapState from '../mixins/mapState';
import userService from '../services/user';
import utils from '../libs/utils';

export default {
  mixins: [mapState],
  data() {
    return {
      modalShow: false,
      AccountList: [],
      storeId: null,
    };
  },
  props: {
    val: {
      type: Boolean,
    },
  },
  model: {
    prop: 'val',
    event: 'change',
  },
  watch: {
    val(val) {
      this.modalShow = val;
    },
  },
  // computed: {

  //   ...mapState,
  // },
  methods: {
    handleModal(isShow) {
      if (isShow) {
        this.storeId = this.storeInfo.id;
        this.$emit('reSetAuthority');
      }
    },
    onConfirm() {
      if (this.storeId === this.storeInfo.id) {
        this.setModal(false);
        // this.modalShow = false;
      } else {
        userService.changeAccount({ storeId: this.storeId }).then((res) => {
          if (res.data.status === 200) {
            console.log(location);

            // const { location } = window;
            location.href = `${location.origin + location.pathname}#/messageList`;
            this.$nextTick(() => {
              location.reload(true);
            });
          } else {
            this.$Message.error(res.data.error);
            // this.modalShow = false;
          }
          this.setModal(false);
        }).catch((err) => {
          this.setModal(false);
          // this.modalShow = false;
          utils.handleError(err);
        });
      }
      // TODO
      // 设置账户，关闭弹窗
      // this.closeModal()
    },
    setModal(val) {
      this.modalShow = val;
      this.$emit('change', this.modalShow);
    },
    closeModal() {
      this.setModal(false);
      // this.modalShow = false;
      // this.$emit('change', this.modalShow);
      // TODO
      // 关闭弹窗
    },
  },
};
</script>
<style lang="less" scoped>
.container{
  padding-right: 42px;
  padding-left: 16px;
  padding-top:8px;
  padding-bottom: 21px;
}
</style>
